import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Button, Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  calculatedViewMode,
  getFilterData,
  getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { APPLICATION_MODULE } from '../../../../configs/moduleNames';
import { getSystemData } from '../../../System/reducer';
import getDefaultSort from '../../../../utils/getDefaultSort';
import { applicationAdditionalColumns, applicationColumns } from '../../../Application/components/applicationColumns';
import { getApplicationData } from '../../../Application/reducer';
import { loadApplicationList } from '../../../Application/actions';
import FilterRow from '../../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import TextSearchInput from '../../../../components/fields/TextInput/TextSearchInput';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';
import { INTERNAL_APPLICATION_STATUS_LIST, PROCEDURE_TYPE_LIST } from '../../../../configs';
import FilterModal from '../../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../../FilterTemplate/components/filter-settings';
import ApplicationsDTO from '../../../../dto/ApplicationsDTO';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';

export function ApplicationBox(props) {
  const { onClose = () => {}, currentApplicant = {} } = props;
  const dispatch = useDispatch();
  const { updatePeriod } = useSelector(getSystemData);
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [sort, setSort] = useState(getDefaultSort(applicationColumns));
  const DTO = new ApplicationsDTO();
  const attributes = DTO.getAttributesByName();
  const {
    loadingList,
    list = [],
    listMeta = {},
  } = useSelector(getApplicationData);
  const filterName = 'applicant-applications-list123';
  const store = useStore();
  const {
    formatMessage,
  } = intlShape;
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData(filterName, {}) });

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[APPLICATION_MODULE].listMeta, opts);
    const viewModeData = calculatedViewMode(filterData.view_mode);
    delete filterData.view_mode;
    const requestData = {
      ...paginationOpts,
      filter: {
        ...filterData,
        ...viewModeData,
        applicant_id: currentApplicant?.id,
      },
      sort,
    };
    const p1 = dispatch(loadApplicationList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  const handleOpenTab = item => {
    window.open(`/application?application_id=${item?.id}`, '_blank');
  };
  return (
    <div className="applicant-body flex-column">
      <TimerLoader loading={loadingList} />
      <div className="applicant-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'applicant.card.menu.application' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.procedure}
            usePortal
            multiple
            options={PROCEDURE_TYPE_LIST}
              // inputProps={getInputPropsWithSearch(getValues, searchParams, setSearchParams, 'procedure', [])}
            portalClassName="procedure-selector"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            usePortal
            placeholder="Статус"
            options={INTERNAL_APPLICATION_STATUS_LIST}
            addPlaceholder
            multiple
          />
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.APPLICATION}
              />
            )
            : null}
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setOpenFilter(true)}>
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
        </FilterRow>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={list}
            columns={applicationColumns}
            additionalColumns={applicationAdditionalColumns}
            changeSort={changeSort}
            sort={sort}
            name="application-grid"
            settingsFormatter={moreFormatter}
            onDoubleClickByRow={item => handleOpenTab(item)}
            rowClassFormatter={rowClassFormatter}
          />
        </div>
        <Pagination meta={listMeta} list={list} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
